import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { BASE_URL } from "./Constants.js"; // Base URL for API requests
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
const Sidebar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null); // To store user profile data.
  const [Admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true); // To handle loading state
  const [error, setError] = useState(null); // To handle errors


  useEffect(() => {
    const token = localStorage.getItem("authToken");
  
    // If token not available → logout
    if (!token) {
      localStorage.clear();
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
  const token = localStorage.getItem("authToken");

  const fetchProfile = async () => {
    try {
      const response = await fetch(`${BASE_URL}profile`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      // ✅ TOKEN INVALID CHECK
      if (!response.ok || data?.error === "Invalid token") {
        localStorage.removeItem("authToken"); // optional cleanup
        navigate("/"); // redirect to login
        return;
      }

      console.log("Fetched Profile Data:", data);
      setUser(data);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchProfile();
}, [navigate]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <nav
      className="sidebar sidebar-offcanvas"
      id="sidebar"
      onMouseEnter={() => {
        document.body.classList.remove("sidebar-icon-only");
      }}
      onMouseLeave={() => {
        document.body.classList.add("sidebar-icon-only");
      }}
    >
      <ul className="nav">
        {/* Dashboard Link */}
        <li className="nav-item">
          <Link className="nav-link" to="/dashboard">
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Dashboard</span>
          </Link>
        </li>
        {(user?.profile?.viva === "Y" ||
          user?.profile?.prepare_question === "Y") && (
            <>
              <li className="nav-item">
                <Link className="nav-link" to="/upload_new">
                  <i className="fas fa-user-graduate menu-icon"></i>
                  <span className="menu-title">Viva New Screen</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/new_reports">
                  <i className="icon-bar-graph menu-icon"></i>
                  <span className="menu-title">Viva New Reports</span>
                </Link>
              </li>
            </>
          )}

        <li className="nav-item">
          <Link className="nav-link" to="/changepassword">
            <i className="fas fa-key menu-icon"></i>
            <span className="menu-title">Change Password</span>
          </Link>
        </li>



        {user?.profile?.is_admin === "Y" && (
          <>
            {/* Settings Section */}
            <li className="nav-item">
              <Link
                className="nav-link"
                data-bs-toggle="collapse"
                to="#ui-basic"
                aria-expanded="false"
                aria-controls="ui-basic"
              >
                <i className="icon-layout menu-icon"></i>
                <span className="menu-title">Settings</span>
                <i className="menu-arrow"></i>
              </Link>

              <div className="collapse" id="ui-basic">
                <ul className="nav flex-column sub-menu">

                  {/* Viva Permissions */}
                  {user?.profile?.viva === "Y" && (
                    <>
                      <li className="nav-item">
                        <Link className="nav-link" to="/upload_new">
                          Update Viva Details
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link className="nav-link" to="/vivalist">
                          Viva List Details
                        </Link>
                      </li>
                    </>
                  )}

                  {/* Question Permissions */}
                  {user?.profile?.prepare_question === "Y" && (
                    <>
                      <li className="nav-item">
                        <Link className="nav-link" to="/question">
                          Question List
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link className="nav-link" to="/Preparequestionlist">
                          Prepare Question
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link className="nav-link" to="/PreparequestionType">
                          Prepare Question Type
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link className="nav-link" to="/employee">
                          <span className="menu-title">Employee List</span>
                        </Link>
                      </li>
                    </>
                  )}

                  {/* Common Menu */}
                  <li className="nav-item">
                    <Link className="nav-link" to="/changepassword">
                      <span className="menu-title">Change Password</span>
                    </Link>
                  </li>

                </ul>
              </div>
            </li>
          </>
        )}

        {/* Reports Section (Admin Only) */}
        {user?.profile?.is_admin === "Y" && (
          <li className="nav-item">
            <Link
              className="nav-link"
              data-bs-toggle="collapse"
              to="#reports-menu"
              aria-expanded="false"
              aria-controls="reports-menu"
            >
              <i className="icon-bar-graph menu-icon"></i>
              <span className="menu-title">Reports</span>
              <i className="menu-arrow"></i>
            </Link>

            <div className="collapse" id="reports-menu">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/reports">
                    Employee Viva Marks
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/reports1">
                    Employee Written Marks
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/new_reports">
                    Viva New Reports
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        )}
        {/* {user?.profile?.is_admin === "Y" && (<li className="nav-item">
          <Link className="nav-link" to="/upload_question">
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Upload Viva Questions</span>
          </Link>
        </li>)} */}
        {(user?.profile?.is_admin === "Y" ||
  user?.profile?.emp_code === "108872") && (
  <li className="nav-item">
    <Link className="nav-link" to="/upload_question">
      <i className="icon-grid menu-icon"></i>
      <span className="menu-title">Upload Viva Questions</span>
    </Link>
  </li>
)}
        {(user?.profile?.is_admin === "Y" ||
  user?.profile?.emp_code === "108872") && (
  <li className="nav-item">
    <Link className="nav-link" to="/upload_written_question">
      <i className="icon-grid menu-icon"></i>
      <span className="menu-title">Upload Written Questions</span>
    </Link>
  </li>
)}

{(
  user?.profile?.emp_code === "108872" ||
  user?.profile?.emp_code === "110104" ||
  user?.profile?.emp_code === "110005" ||
  user?.profile?.emp_code === "108224" || 
  user?.profile?.emp_code === "108227"
) && (
  <li className="nav-item">
    <Link className="nav-link" to="/getPdf">
      <i className="icon-cloud-download menu-icon"></i>
      <span className="menu-title">Get Pdf</span>
    </Link>
  </li>
)}

{(
  user?.profile?.emp_code === "108872" ||
  user?.profile?.emp_code === "110104" ||
  user?.profile?.emp_code === "110005" ||
  user?.profile?.emp_code === "108224" || 
  user?.profile?.emp_code === "108227"
) && (
  <li className="nav-item">
    <Link className="nav-link" to="/getPdfAll">
      <i className="icon-cloud-download menu-icon"></i>
      <span className="menu-title">Get Pdf All</span>
    </Link>
  </li>
)}

      </ul>
    </nav>
  );
};

export default Sidebar;
